import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { centsToDollars, totalForUsersToDollars } from '../utils'
import { Button, Text } from 'components/base'
import PlanDescription from './PlanDescription'
import CouponLabel from './CouponLabel'
import Tabs from 'components/Utils/Tabs'

export default class PlanSelector extends Component {
  static propTypes = {
    plans: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedPlanIndex: PropTypes.number,
    onSelectPlan: PropTypes.func.isRequired,
    onSelectAndUpgrade: PropTypes.func.isRequired,
    activeUsersCount: PropTypes.number.isRequired,
    coupon: PropTypes.any,
  }

  render() {
    const {
      plan,
      plans,
      selectedPlanIndex,
      onSelectPlan,
      onSelectAndUpgrade,
      activeUsersCount,
      coupon,
    } = this.props

    // For now we just have 2 plans, yearly & monthly.
    const monthlyPlan = plans.find(p => !p.isFree && p.interval === 'month')
    const yearlyPlan = plans.find(p => !p.isFree && p.interval === 'year')
    const selectedPlan = plans[selectedPlanIndex]
    const isCurrentPlan = plan && plan.id === selectedPlan.id

    const options = [
      {
        id: monthlyPlan.id,
        label: 'Monthly',
        isActive: selectedPlan.id === monthlyPlan.id,
        onClick: () => {
          onSelectPlan(0)
        },
      },
      {
        id: yearlyPlan.id,
        label: 'Yearly',
        isActive: selectedPlan.id === yearlyPlan.id,
        onClick: () => {
          onSelectPlan(1)
        },
      },
    ]

    return (
      <div>
        <div style={{ width: 560 }}>
          <PlanDescription>
            <Tabs className="margin-bottom-larger" options={options} />
            <div className="margin-bottom-normal flexbox flexbox-align-center flexbox-column">
              <div className="margin-bottom-normal ">
                <div className="">
                  <span
                    style={{ fontSize: 32 }}
                    className="shade-05 font-weight-bold "
                  >
                    {centsToDollars(selectedPlan.monthlyPricePerUser)}
                  </span>
                  <Text.Detail inline>/user/month</Text.Detail>
                </div>
                {selectedPlan.discountPercentage && (
                  <div className="margin-top-small flexbox flexbox-space-around">
                    <div className="shade-100 background-yellow bold padding-horizontal-small padding-vertical-smaller radius-largest font-size-small">
                      Save {selectedPlan.discountPercentage}%
                    </div>
                  </div>
                )}
              </div>
              {activeUsersCount > 1 && (
                <Text.Detail className="center-text">
                  With currently {activeUsersCount} active users <br /> you
                  would pay{' '}
                  {totalForUsersToDollars(
                    selectedPlan.monthlyPricePerUser,
                    activeUsersCount
                  )}{' '}
                  per month
                </Text.Detail>
              )}
            </div>
            {isCurrentPlan ? (
              <Button.Secondary className="margin-bottom-large" disabled>
                Your current plan
              </Button.Secondary>
            ) : (
              <Button.Primary
                className="margin-bottom-large"
                style={{ width: 300 }}
                onClick={() => onSelectAndUpgrade(selectedPlanIndex)}
              >
                Upgrade
              </Button.Primary>
            )}
          </PlanDescription>
          {coupon && (
            <div className="inline-block">
              <CouponLabel coupon={coupon} />
            </div>
          )}
          <div className="margin-top-large">
            <Text.Detail className="margin-bottom-small">
              The price will automatically update when new user accounts are
              added, removed or go inactive.
            </Text.Detail>
            <div>
              <Text.ExternalLink
                target="_blank"
                rel="noopener noreferrer"
                href="https://help.slite.com/"
              >
                FAQ
              </Text.ExternalLink>
              <span> - </span>
              <Text.ExternalLink
                target="_blank"
                rel="noopener noreferrer"
                href="https://slite.com/customer-terms"
              >
                Customer term of services
              </Text.ExternalLink>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
